export default __webpack_public_path__ + "static/media/analog_2_Pin_Input@2x.cee52d21.png";